var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnverifiedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#BAC0BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17726 4V8.761C6.17726 9.37433 6.34209 9.85733 6.67176 10.21C7.00142 10.555 7.44609 10.7275 8.00576 10.7275C8.56542 10.7275 9.00626 10.555 9.32826 10.21C9.65792 9.85733 9.82276 9.37433 9.82276 8.761V4H11.3753V8.7955C11.3753 9.47017 11.2373 10.0643 10.9613 10.578C10.6929 11.084 10.3058 11.475 9.79976 11.751C9.29376 12.027 8.69576 12.165 8.00576 12.165C7.31576 12.165 6.71392 12.027 6.20026 11.751C5.69426 11.475 5.30326 11.084 5.02726 10.578C4.75892 10.0643 4.62476 9.47017 4.62476 8.7955V4H6.17726Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnverifiedIcon);
export default __webpack_public_path__ + "static/media/unverified_icon.5767872ce705c2538f4a16b6a4bccfe4.svg";
export { ForwardRef as ReactComponent };